// SU-Shop Main Application
// Simplified Guest Checkout - Single Page

import { renderHomepage } from './pages/home';
import { renderOrderConfirmation } from './pages/order-confirmation';

// ========== ROUTING ==========
async function render() {
    const path = window.location.pathname;
    const app = document.getElementById('app');
    if (!app) return;

    // Handle both /payment/callback/order/:orderId and /order/:orderId
    if (path.startsWith('/payment/callback/order/')) {
        const orderId = path.split('/')[4];
        await renderOrderConfirmation(app, orderId);
    } else if (path.startsWith('/order/')) {
        const orderId = path.split('/')[2];
        await renderOrderConfirmation(app, orderId);
    } else {
        await renderHomepage(app);
    }
}

// ========== INITIALIZATION ==========
window.addEventListener('popstate', () => void render());

document.addEventListener('DOMContentLoaded', () => {
    void render();
});
